<template>
<div class="patientRegistration">
    <vx-card>
         <vs-row v-if="this.$route.query.addFlag">
            <vs-col class="w-1/2">
                <h4 style="margin-left:10%"></h4>
            </vs-col>
            <vs-col class="w-1/2">
                <div style="margin-left:90%;cursor:pointer;">
                    <feather-icon icon="XIcon" class="custom-class" title="close" @click="exit"></feather-icon>
                </div>
            </vs-col>
        </vs-row>
        <div class="vx-row" style="padding-left: 30px;padding-right: 30px;padding-top: 30px;padding-bottom:30px;">
             
            <div class="vx-col w-full md:w-1/2 row1">
            
                <div class="vx-row mb-4">

                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">Patient Id</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input readonly class="w-full" name="patientId" v-model="patientId" />
                    </div>
                    <div class="vx-col sm:w-1/12 w-full" v-show="searchFlag">
                        <SearchIcon class="custom-class testTable" @click="popupActivo=true" style="width:20px;margin-top:5px;cursor:pointer" title="Search"></SearchIcon>
                    </div>
                </div>

                <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">Patient Name*</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input   ref="patientNameInput" class="w-full" v-validate="'required|alpha_spaces'" name="patientName" v-model="patientName"  @blur="formatPatientName"/>
                        <span class="text-danger text-sm" v-show="errors.has('patientName')">{{ errors.first('patientName') }}</span>
                    </div>
                </div>

                <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">Mobile Number*</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input class="w-full" v-validate="'required|numeric|max:10|min:10'" name="phoneNo" v-model="phoneNo" />
                        <vs-checkbox v-model="smsNotification" v-if="phoneNo">SMS Notification</vs-checkbox>
                        <span class="text-danger text-sm" v-show="errors.has('phoneNo')">{{ errors.first('phoneNo') }}</span>
                    </div>
                </div>

               
                <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">Gender*</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <select v-model="gender" class=" vs-select--input myselect" style="height:36px;" placeholder="Select" v-validate="'required'" name="Gender">
                            <option v-for="(item,index) in genderOption" v-bind:key="index" :value="item.genderCode">{{item.GenderList}}</option>
                        </select>
                        <span class="text-danger text-sm" v-show="errors.has('Gender')">{{ errors.first('Gender') }}</span>
                    </div>
                </div>

                <!--<div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">DOB</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <flat-pickr :config="configdateTimePicker" class="w-full" v-model="dob" placeholder="dd-mm-yyyy" />
                    </div>
                </div>-->

                <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">Age*</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input class="w-full"   v-validate="'required|regex:^[A-Za-z0-9 ]+$'"  name="age" v-model="age" />
                        <span class="text-danger text-sm" v-show="errors.has('age')">{{ errors.first('age') }}</span>
                    </div>
                </div>

                 <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">Place</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input name="place"  class="w-full" v-validate="'alpha_spaces'"  v-model="place" />
                        <span class="text-danger text-sm" v-show="errors.has('place')">{{ errors.first('place') }}</span>
                    </div>
                </div>
                

                <!--<div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">Blood Group</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <select v-model="bloodGroup" class=" vs-select--input myselect" style="height:36px;" name="bloodgroup">
                            <option v-for="(item,index) in options" v-bind:key="index" :value="item.id">{{item.name}}</option>
                        </select>

                    </div>
                </div>-->

            </div>

            <div class="vx-col w-full md:w-1/2 row2">
                <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">Register Date</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input readonly class="w-full" v-validate="'required'" name="registerDate" v-model="registerDate" />
                    </div>
                </div>

                <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">Occupation</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input class="w-full" v-validate="'alpha_spaces'" name="occupation" v-model="occupation" />
                        <span class="text-danger text-sm" v-show="errors.has('occupation')">{{ errors.first('occupation') }}</span>
                    </div>
                </div>

              <!-- <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">RefferedBy</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input class="w-full" v-validate="'alpha_spaces'" name="refferedBy" v-model="refferedBy" />
                        <span class="text-danger text-sm" v-show="errors.has('refferedBy')">{{ errors.first('refferedBy') }}</span>
                    </div>
                </div>-->

                <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">Street Address</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input name="streetAddress"  class="w-full" v-model="streetAddress" />
                    </div>
                </div>

                <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">Pincode</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input class="w-full" v-validate="'numeric|max:6|min:6'" name="pinCode" v-model="pinCode" />
                        <span class="text-danger text-sm" v-show="errors.has('pinCode')">{{ errors.first('pinCode') }}</span>
                    </div>
                </div>

                <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">City</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input class="w-full" v-validate="'alpha_spaces'" name="city" v-model="city" />
                        <span class="text-danger text-sm" v-show="errors.has('city')">{{ errors.first('city') }}</span>
                    </div>
                </div>

                 <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full topPad">
                        <span class="inputText">Email</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input class="w-full" v-validate="'email'" name="email" v-model="email" />
                        <vs-checkbox v-model="emailNotification" v-if="email">Email Notification</vs-checkbox>
                        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                    </div>
                </div>

            </div>
        </div>

        <div class="vx-row">

        </div>
        <div class="vx-row" style="margin-left:50%;">
            <div class="vx-col w-full">
                <vs-button class="mr-3 mb-2" @click="navToregister">{{buttontext}}</vs-button>
                <vs-button @click="$router.go(-1)" color="warning" type="border" class="mb-2"> Cancel</vs-button>
            </div>
        </div>
        <div>
        </div>
        <div :class="{'activeLoading':activeLoading}" :id="[`loading-material`]" class="vs-con-loading__container loading-example">
        </div>
    </vx-card>

    <!-- SearchPopUp -->

    <vs-popup class="holamundo" title="SearchPatient" :active.sync="popupActivo">
        <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-60 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="contacts" :floatingFilter="true" @grid-ready="onGridReady" :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true">
        </ag-grid-vue>
        <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
    </vs-popup>

    <!-- SearchPopUp -->

</div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {
    French as FrenchLocale
} from 'flatpickr/dist/l10n/fr.js';

import {
    SearchIcon
} from 'vue-feather-icons'
import {
    AgGridVue
} from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'

export default {
    name: "patientRegistration",
    components: {
        SearchIcon,
        AgGridVue,
        flatPickr
    },

    data() {
        return {
            activeLoading: false,
            popupActivo: false,
            searchFlag: true,
            configdateTimePicker: {
                allowInput: true,
                dateFormat: "d-m-Y",
                onClose: (selectedDates, dateStr, fp) => {
                    fp.setDate(fp._input.value);
                    this.setAge();
                }
            },
            gridOptions: {
                onFilterChanged: this.onGridReady,
                onRowDoubleClicked: this.changePatient,
                rowSelection: "single",
                rowModelType: 'infinite',
                rowHeight: 40,
                floatingFiltersHeight: 40,
                headerHeight: 40,
                rowStyle: {
                    'text-align': 'center'
                },
            },
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {
                sortable: true,
                resizable: true,
                filter: true,
                suppressMenu: true,
                floatingFilterComponentParams: {
                    suppressFilterButton: true
                },
                filterParams: {
                    newRowsAction: 'keep',
                    browserDatePicker: true
                }
            },
            columnDefs: [{
                    headerName: 'Name',
                    field: 'patientName',
                    filter: true,
                    width: 159,
                    cellStyle: {
                        'text-align': 'left'
                    }
                },
                {
                    headerName: 'Phone',
                    field: 'phoneNo',
                    filter: true,
                    width: 175
                },
                {
                    headerName: 'Address',
                    field: 'address',
                    filter: true,
                    width: 231,
                    cellStyle: {
                        'text-align': 'left'
                    }
                },
            ],

            patientId: "New",
            patientName: this.$route.query.patientName || "",
            registerDate: this.changeDateFormat(new Date()),
            phoneNo: this.$route.query.phoneNo,
            email: "",
            gender: "",
            dob: null,
            age: this.$route.query.patientAge || "",
            bloodGroup: "",
            place:"",
            occupation: "",
            refferedBy: " ",
            streetAddress: "",
            pinCode: "",
            city: "",
            smsFlagvalue: "",
            emailFlagvalue: "",
            smsNotification: false,
            emailNotification: false,
            buttontext: "Next",
            tokenNo: this.$route.query.tokenNo,

            options: [{
                    id: 'A+ve',
                    name: 'A+ve'
                },
                {
                    id: 'B+ve',
                    name: 'B+ve'
                },
                {
                    id: 'AB+ve',
                    name: 'AB+ve'
                },
                {
                    id: 'O+ve',
                    name: 'O+ve'
                },
                {
                    id: 'A-ve',
                    name: 'A-ve'
                },
                {
                    id: 'B-ve',
                    name: 'B-ve'
                },
                {
                    id: 'AB-ve',
                    name: 'AB-ve'
                },
                {
                    id: 'O-ve',
                    name: 'O-ve'
                }
            ],
            genderOption: [{
                    genderCode: "",
                    GenderList: "Select",
                }, {
                    genderCode: "Female",
                    GenderList: "Female",
                },
                {
                    genderCode: "Male",
                    GenderList: "Male",
                }
            ],
            contacts: [{}],

        }
    },
    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize()
            else return 7
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages()
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
                this.onGridReady()
            }
        }
    },
    watch: {
        phoneNo(newVal) {
    if (newVal && newVal.length === 10) {
      this.checkExistingPatient(newVal);
    }
  },
        '$route'() {
            
            if (this.$route.query.patientId) {
                this.patientId = this.$route.query.patientId;
            } else {
                this.patientId = 'New';
            }
            if (this.$route.query.source === 'ip') {
  this.buttontext = "Save/Next"; 
}

           else if (this.$route.query.patientId && this.$route.query.tokenNo && this.$route.query.phoneNo) {
                this.buttontext = "Next";
            } else if (!this.$route.query.patientId && this.$route.query.tokenNo && this.$route.query.phoneNo) {        
             this.buttontext = "Save/Next";
            } else if (!this.$route.query.patientId && !this.$route.query.tokenNo && !this.$route.query.phoneNo) {
                this.buttontext = "Save";
                this.searchFlag = false;

            } else if (this.$route.query.patientId && !this.$route.query.tokenNo && !this.$route.query.phoneNo) {
                this.buttontext = "Save";
                this.searchFlag = false;
            }
            if (this.patientId != 'New') {
                this.gePatientDetails();
            }
        }
    },
    beforeMount() {
        if (this.$route.query.patientId) {
            this.patientId = this.$route.query.patientId;
        } else {
            this.patientId = 'New';
        }
         if (this.$route.query.source === 'ip') {
  this.buttontext = "Save/Next"; 
}

           else if (this.$route.query.patientId && this.$route.query.tokenNo && this.$route.query.phoneNo) {
            this.buttontext = "Next";
        } else if (!this.$route.query.patientId && this.$route.query.tokenNo && this.$route.query.phoneNo) {
            this.buttontext = "Save/Next";
        } else if (!this.$route.query.patientId && !this.$route.query.tokenNo && !this.$route.query.phoneNo) {
            this.buttontext = "Save";
            this.searchFlag = false;

        } else if (this.$route.query.patientId && !this.$route.query.tokenNo && !this.$route.query.phoneNo) {
            this.buttontext = "Save";
            this.searchFlag = false;
        }
        if (this.patientId != 'New') {
            this.gePatientDetails();
        }

    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.$nextTick(() => {
    const vsInput = this.$refs.patientNameInput;
    if (vsInput && vsInput.$el) {
      const nativeInput = vsInput.$el.querySelector('input');
      if (nativeInput) nativeInput.focus();
    }
  });
    },
    methods: {
        async checkExistingPatient(phoneNo) {
              if (this.patientId && this.patientId !== 'New') return;
  try {
    const request = {
      companyId: this.$session.get('companyId'),
      phoneNo: phoneNo
    };

    const res = await this.$http.post(
      "checkpatientRegister",
      JSON.stringify(request),
      { headers: { "Content-Type": "application/json" } }
    );


  if (res.data.statusCode === 200 && res.data.data && res.data.data.patientId) {
      const existingId = res.data.data.patientId;
     const existingName = res.data.data.patientName 
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: '⚠️ Phone Number Already Exists',
        text: `This phone number already exists in the name of "${existingName}".Do you want to continue with the existing patient?`,
        acceptText: 'Yes, Continue With Existing Patient',
        cancelText: 'No, Create New Patient',
        accept: () => {
        const query = { patientId: existingId };
        if (this.$route.query.addFlag) {
    query.addFlag = this.$route.query.addFlag;
  }
  if (this.$route.query.tokenNo) {
    query.tokenNo = this.$route.query.tokenNo;
  }

          this.$router.push({
            path: 'patientRegistration',
            query
          });
        },
        cancel: () => {
          // Do nothing — user can continue creating a new one
        }
      });
    }

  } catch (error) {
    console.error('Error checking existing patient:', error);
  }
},

         exit() {
           if(this.$route.query.addFlag){
                this.$store.dispatch('updateBackOpFlag', true); 
                this.$router.push({
                path:'OpTicket',
                 });
            }
         },
         formatPatientName() {
    if (this.patientName) {
      this.patientName = this.patientName
        .trim()
        .toLowerCase()
        .replace(/\b\w/g, char => char.toUpperCase());
    }
  },
        openLoading() {
            this.activeLoading = true
            this.$vs.loading();
        },
        changePatient() {
            var selectedrow = this.gridApi.getSelectedRows();
            var selectedPatient = ""
            selectedrow.forEach((value) => {
                selectedPatient = value.patientId;
            });
            this.$router.push({
                path: 'patientRegistration',
                query: {
                    patientId: selectedPatient,
                    tokenId: this.tokenNo,
                    phoneNo: this.phoneNo
                }
            })
            this.popupActivo = false;
            this.buttontext = "Next";
        },
        onGridReady(params) {
            this.gridApi.showLoadingOverlay()
            var request = {
                companyId: this.$session.get('companyId'),
                currentPage: this.gridApi.paginationGetCurrentPage() + 1,
                limit: this.gridApi.paginationGetPageSize(),
                filter: this.gridApi.getFilterModel()
            }
            var datasource = {
                getRows: (params) => {
                    this.$http.post(
                            "searchpatients",
                            JSON.stringify(request), {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        .then(response => {
                            params.successCallback(response.data.data.records, response.data.data.recordsTotal);
                            this.gridApi.hideOverlay();

                        });
                }
            }
            this.gridApi.setDatasource(datasource);
        },

        navToregister() {
            if (this.buttontext == "Save") {
                this.register();
            } else if (this.buttontext == "Next") {
                this.$router.push({
                    path: 'OpTicket',
                    query: {
                        patientId: this.patientId,
                        tokenId: this.tokenNo
                    }
                })

            } else if (this.buttontext == "Save/Next") {
                this.register();
            }
        },
        register: function () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.openLoading();
                    if (this.smsNotification == true) {
                        this.smsFlagvalue = 'Y';
                    } else {
                        this.smsFlagvalue = 'N';
                    }
                    if (this.emailNotification == true) {
                        this.emailFlagvalue = 'Y';
                    } else {
                        this.emailFlagvalue = 'N';
                    }
                    var form = {
                        companyId: this.$session.get('companyId'),
                        patientId: this.patientId,
                        patientName: this.patientName,
                        registerDate: this.registerDate,
                        phoneNo: this.phoneNo,
                        email: this.email,
                        gender: this.gender,
                        dob: this.dob,
                        age: this.age,
                        bloodGroup: this.bloodGroup,
                        occupation: this.occupation,
                        refferedBy: this.refferedBy,
                        streetAddress: this.streetAddress,
                        pinCode: this.pinCode,
                        city: this.city,
                        smsFlagvalue: this.smsFlagvalue,
                        emailFlagvalue: this.emailFlagvalue,
                        smsNotification: this.smsNotification,
                        emailNotification: this.emailNotification,
                        place:this.place
                    };
                    console.log('Form to submit:', form);
                    this.$http.post(
                            "savepatientdetails",
                            JSON.stringify(form), {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            }
                        )
                        .then(response => {
                            this.$vs.loading.close();
                            this.patientId = response.data.data.patientId;
                            this.$vs.notify({
                                title: 'Saved Successfully',
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-check',
                                position: 'top-center'
                            });
                             if (this.buttontext == "Save/Next") {
          // Check if coming from IP flow
          if (this.$route.query.source === 'ip') {
            this.$router.push({
              path: '/ipDetails',
              query: { patientId: this.patientId }
            });
          } else {
            this.$router.push({
              path: 'OpTicket',
              query: { patientId: this.patientId, tokenId: this.tokenNo }
            });
          }
        } else {
          setTimeout(() => {
            if (this.$route.query.addFlag) {
              this.$store.dispatch('updateBackOpFlag', true);
              this.$store.dispatch('updatePatientId', this.patientId);
              this.$router.push({ path: 'OpTicket' });
            } else {
              this.$router.go(-1);
            }
          }, 1000);
        }
      });
    } else {
      this.errors.any();
    }
  });
},
        setAge(selectedDates, dateStr, instance) {

            var dateofBirth = this.dob;
            var dobArray = dateofBirth.split("-");
            dateofBirth = dobArray[0] + '-' + dobArray[1] + '-' + dobArray[2];
            var age = this.getAge(dateofBirth);
            if (this.isNumeric(age)) {
                this.age = age;
            } else {
                this.age = '';
            }
        },
        getAge: function (dateString) {
            var today = new Date();
            var birthDate = new Date(dateString);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        },
        isNumeric: function (n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        },
        changeDateFormat:function(date){
            var d= date;
            var month = '' + (d.getMonth() + 1);
            var day = '' + d.getDate();
            var year = d.getFullYear();

         if (month.length < 2) 
           month = '0' + month;
         if (day.length < 2) 
           day = '0' + day;

          return [day, month, year].join('-');
        },
        gePatientDetails: function () {

            var request = {
                companyId: this.$session.get('companyId'),
                regNo: this.patientId
            };
            console.log(JSON.stringify(request));
            this.$http.post(
                    "getpatiententry",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                )
                .then(response => {
                
                    this.patientName = response.data.data.name;
                    this.gender = response.data.data.gender;
                    this.age = response.data.data.age;
                    this.bloodGroup = response.data.data.bloodGroup;
                    this.phoneNo = response.data.data.phoneNo;
                    this.email = response.data.data.email;
                    this.registerDate = response.data.data.registerDate;
                    this.dob = response.data.data.dob;
                    this.occupation = response.data.data.occupation;
                    this.refferedBy = response.data.data.refferedBy;
                    this.streetAddress = response.data.data.address;
                    this.pinCode = response.data.data.pinCode;
                    this.city = response.data.data.city;
                    this.smsFlagvalue = response.data.data.smsFlagvalue;
                    this.emailFlagvalue = response.data.data.emailFlagvalue;
                    this.smsNotification = response.data.data.smsNotification;
                    this.emailNotification = response.data.data.emailNotification;
                    this.place = response.data.data.place;
                })
              
        }
    }

}
</script>

<style scoped>
.row1 {
    padding-left: 70px;
}

.row2 {
    padding-left: 70px;

}

.ag-grid-table {
    height: 400px;
}

.ag-header-cell-label {
    justify-content: center;
}
.inputText{
    font-weight: 600;
}
.topPad{
    padding-top: 7px;
}
</style>
